import React, { Component } from "react";
import Slider from "react-slick";

import { instagramUrl, facebookUrl, tiktokUrl } from "../../utils/constants";

// Import Images
import slide1 from "../../images/slider/slide1.jpg";
import slide2 from "../../images/slider/slide2.jpg";
import slide3 from "../../images/slider/slide3.jpg";
import slide4 from "../../images/slider/slide4.jpg";

const slides = [
  {
    src: slide1,
    alt: "Lackeringstjänster på KBScenter | Kungälv Bilskadecenter",
    subTitle: "Bästa servicen någonsin",
    title: "Erbjuder en Professionell och Pålitlig Service",
  },
  {
    src: slide2,
    alt: "Biltvätt på KBScenter | Kungälv Bilskadecenter",
    subTitle: "Kvalitetstjänst garanterad",
    title: "Din Tillfredsställelse är Vår Prioritet",
  },
  {
    src: slide3,
    alt: "Rekondtjänster på KBScenter | Kungälv Bilskadecenter",
    subTitle: "Betrodd av många",
    title: "Upplev excellens i varje steg",
  },
  {
    src: slide4,
    alt: "Bilservice på KBScenter | Kungälv Bilskadecenter",
    subTitle: "Expertteam",
    title: "Kompetenta yrkesverksamma som du kan lita på",
  },
];

const socialLinks = [
  { name: "Instagram", url: instagramUrl },
  { name: "Tiktok", url: tiktokUrl },
  { name: "Facebook", url: facebookUrl },
  // { name: "Youtube", url: "https://youtube.com/" },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  appendDots: (dots) => (
    <div style={{ bottom: "20px" }}>
      <ul style={{ margin: "0px" }}> {dots} </ul>
    </div>
  ),
};

class HomeSlider extends Component {
  render() {
    return (
      <>
        <div className="ttr-slider style-1">
          <Slider className="ttr-swiper02" {...settings}>
            {slides.map((slide, index) => (
              <div className="slider-item" key={index}>
                <div className="slider-img">
                  <img src={slide.src} alt={slide.alt} />
                </div>
                <div className="slider-content container text-center text-white">
                  <div className="content-inner">
                    <h6 className="sub-title">{slide.subTitle}</h6>
                    <h3 className="title">
                      {slide.title.split("&").map((line, i) => (
                        <span key={i}>
                          {line}
                          {i === 0 && <br />}
                        </span>
                      ))}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="social-sidebar">
          <ul>
            {socialLinks.map((social, index) => (
              <li key={index}>
                <a target="_blank" rel="noreferrer" href={social.url}>
                  {social.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </>
    );
  }
}

export default HomeSlider;
